module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/5-1887b634471f6ff09437cd063fa830f9.jpg";